/*
 * Copyright © 2018, Rezo Zero
 *
 * @file BubbleManager.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 */

import AManager from '../abstracts/AManager'
import Bubble from './Bubble'
import { $window } from '../utils/environment'
import * as Utils from '../utils/Utils'

export default class BubbleManager extends AManager {
    constructor () {
        super()

        /**
         * @type {Array<Bubble>}
         */
        this.objects = []

        if (Utils.isMobile()) {
            this.size = 5
        } else {
            this.size = 10
        }
    }

    preload (p5) {
        // Build Bubbles
        for (let i = 0; i < this.size; i += 1) {
            const object = new Bubble(i)
            this.objects.push(object)
        }
    }

    setup (p5) {
        for (let i = 0; i < this.size; i += 1) {
            const object = this.objects[i]
            object.setup(p5)

            window.setTimeout(() => {
                object.active = true
            }, i * 500)
        }

        $window.triggerHandler('bubbleManager.setup')
    }

    draw (p5) {
        for (let object of this.objects) {
            object.draw(p5)
        }
    }

    colorWhite () {
        for (let object of this.objects) {
            object.changeColor(object.colors.white)
        }
    }

    colorInitial (p5) {
        for (let object of this.objects) {
            object.changeColor(object.initialColor)
        }
    }

    randomPositions (p5) {
        for (let object of this.objects) {
            object.targetX = p5.random(p5.width)
        }
    }

    randomSplitPositions (p5) {
        for (let object of this.objects) {
            object.targetX = p5.random(p5.width / 2) + p5.round(object.type) * p5.width / 2
        }
    }

    centerPositions (p5) {
        for (let object of this.objects) {
            let offset = object.type === 0 ? p5.random(-100, 0) : p5.random(100, 0)
            object.targetX = p5.width / 2 + offset
        }
    }

    reduceOpacity () {
        for (let object of this.objects) {
            object.changeOpacity(0.2)
        }
    }

    resetOpacity () {
        for (let object of this.objects) {
            object.changeOpacity(object.initialOpacity)
        }
    }

    changeColors (newColor = 255) {}
}



// WEBPACK FOOTER //
// ./webpack/js/bubbles/BubbleManager.js